export default "__VITE_ASSET__BzvqVM0G__"